export default __webpack_public_path__ + "static/media/Icon-round-distribute.971435cc.png";